export default __webpack_public_path__ + "firebase-messaging-sw.b005b9d7a686e3b1d198349952edd449.js";